import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";
import { getCurrentUser } from "./authActions";
import {
  SET_GROUP,
  SET_GROUP_STORE,
  SET_TEAM_MEMBER,
  RESET_GROUP_STATE,
  SET_GROUP_PERMISSIONS,
  TOGGLE_SWITCH_STORE_POPUP,
} from "../types";

export const setGroupPermissions = (data) => (dispatch) => {
  dispatch({
    payload: data,
    type: SET_GROUP_PERMISSIONS,
  });
};

export const setDraftStore = (data) => (dispatch) => {
  dispatch({
    type: SET_GROUP_STORE,
    payload: data,
  });
};

export const createGroup = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post("/v1/groups", data)
      .then((res) => {
        dispatch({
          type: SET_GROUP,
          payload: res.data.payload,
        });

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateGroupName = (groupId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/groups/group-name/${groupId}`, data)
      .then((res) => {
        dispatch(getCurrentUser())
          .then(() => resolve(res.data.payload))
          .catch(() => window.location.reload());
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const createGroupStore = (data, id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/groups/store/${id}`, data)
      .then((res) => {
        let payload;
        if (Array.isArray(res?.data?.payload)) {
          payload = res?.data?.payload?.[0];
        } else {
          payload = res.data.payload;
        }
        dispatch(setDraftStore(payload));

        return resolve(payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else if (err?.response?.data?.code === 400) {
          toastr.error("Bad Request", err?.response?.data?.message);

          return reject(err?.response?.data?.message);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const createGroupStoreSubs = (data, storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/subscriptions/add/${storeId}`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

// for the case when store is already added
export const createGroupStore2 = (data, storeId) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/groups/${storeId}/credentials/create`, data)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else if (err?.response?.data?.code === 400) {
          toastr.error("Bad Request", err?.response?.data?.message);

          return reject(err?.response?.data?.message);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const toggleSwitchStore = (isPopupOpen) => (dispatch) => {
  dispatch({
    type: TOGGLE_SWITCH_STORE_POPUP,
    payload: !isPopupOpen,
  });
};

export const getRolesAndPermSeed = () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/team-invite/seed/roles/features`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation errors:",
            err?.response?.data?.errors?.map((err) => err?.msg)?.join(", ")
          );
        } else if (err?.response?.data?.code === 400) {
          toastr.error("Bad Request", err?.response?.data?.message);

          return reject(err?.response?.data?.message);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const setTeamMember = (data) => (dispatch) => {
  dispatch({
    type: SET_TEAM_MEMBER,
    payload: data,
  });
};

export const createTeamMember = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/team-invite`, data)
      .then((res) => {
        dispatch(setTeamMember(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          if (data?.page === 1) return reject(err?.response?.data?.errors);
          else {
            toastr.error(
              "Validation errors:",
              err?.response?.data?.errors?.map((err) => err?.msg)?.join(", ")
            );
          }
        } else if (err?.response?.data?.code === 400) {
          toastr.error("Bad Request", err?.response?.data?.message);

          return reject(err?.response?.data?.message);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getTeamMember = (customUserId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/team-invite/${customUserId}`)
      .then((res) => {
        dispatch(setTeamMember(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          return reject(err?.response?.data?.errors);
        } else if (err?.response?.data?.code === 400) {
          toastr.error("Bad Request", err?.response?.data?.message);

          return reject(err?.response?.data?.message);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const publishTeamMember = (customUserId) => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/team-invite/publish/${customUserId}`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation errors:",
            err?.response?.data?.errors?.map((err) => err?.msg)?.join(", ")
          );
        } else if (err?.response?.data?.code === 400) {
          toastr.error("Bad Request", err?.response?.data?.message);

          return reject(err?.response?.data?.message);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getTeamMemberList = (ownerId, page = 1) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/team-invite/list/custom-users/${ownerId}?page=${page}`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation errors:",
            err?.response?.data?.errors?.map((err) => err?.msg)?.join(", ")
          );
        } else if (err?.response?.data?.code === 400) {
          toastr.error("Bad Request", err?.response?.data?.message);

          return reject(err?.response?.data?.message);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const deleteTeamMember = (customUserId) => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/team-invite/custom-user/delete/${customUserId}`)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation errors:",
            err?.response?.data?.errors?.map((err) => err?.msg)?.join(", ")
          );
        } else if (err?.response?.data?.code === 400) {
          toastr.error("Bad Request", err?.response?.data?.message);

          return reject(err?.response?.data?.message);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const resetGroup = () => (dispatch) => {
  dispatch({
    type: RESET_GROUP_STATE,
  });
};
